import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "button"];
  static values = {
    showText: String,
    hideText: String,
    showIcon: String,
    hideIcon: String,
    initialState: String  // "hidden" ou "visible"
  };

  connect() {
    // Appliquer l'état initial
    if (this.initialStateValue === "visible") {
      this.show();
    } else {
      this.hide();
    }
  }

  toggle() {
    const isVisible = !this.contentTarget.hidden;
    
    if (isVisible) {
      this.hide();
    } else {
      this.show();
    }
  }

  show() {
    this.contentTarget.hidden = false;
    this.updateButtonContent(this.hideText, this.hideIcon);
  }

  hide() {
    this.contentTarget.hidden = true;
    this.updateButtonContent(this.showText, this.showIcon);
  }

  updateButtonContent(text, iconHtml) {
    // Décoder le HTML si nécessaire (base64 ou URL encoded)
    const decodedIconHtml = this.decodeIconHtml(iconHtml);
    
    // Mettre à jour tous les boutons toggle
    this.buttonTargets.forEach(button => {
      button.innerHTML = `${decodedIconHtml}${text}`;
    });
  }

  decodeIconHtml(iconHtml) {
    // Si l'icône commence par 'data:', c'est du base64
    if (iconHtml.startsWith('data:')) {
      return atob(iconHtml.replace('data:', ''));
    }
    
    // Si l'icône contient des caractères encodés URL
    if (iconHtml.includes('%')) {
      return decodeURIComponent(iconHtml);
    }
    
    // Sinon, retourner tel quel
    return iconHtml;
  }

  // Getters pour les valeurs avec fallbacks
  get showText() {
    return this.hasShowTextValue ? this.showTextValue : "Afficher";
  }

  get hideText() {
    return this.hasHideTextValue ? this.hideTextValue : "Masquer";
  }

  get showIcon() {
    return this.hasShowIconValue ? this.showIconValue : this.defaultShowIcon;
  }

  get hideIcon() {
    return this.hasHideIconValue ? this.hideIconValue : this.defaultHideIcon;
  }

  get defaultShowIcon() {
    return '<svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 0 14"/></svg>';
  }

  get defaultHideIcon() {
    return '<svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>';
  }
}
